import { Tabs } from 'antd'
import React, { ReactElement, useEffect, useState } from 'react'
import { RechargeRecord } from './exchangeRecord/RechargeRecord'
import { ConsumptionRecord } from './exchangeRecord/ConsumptionRecord'
import { ExchangeRecord } from './exchangeRecord/ExchangeRecord'
import styles from './ExchangeRecordPage.module.css'
import { SJQXChecks } from '../../models/dataPersion'
import { useLocation } from 'react-router-dom'
import { RootDispatch } from '../../app/store'
import { useDispatch } from 'react-redux'
import { getCheckPermissionAsync } from '../FunctionSetting/dataPermission/dataPermissionSlice'
import { unwrapResult } from '@reduxjs/toolkit'

const { TabPane } = Tabs

export const ExchangeRecordPage = (): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const location: any = useLocation()

  const [QXData, setQXData] = useState<any>(location?.state?.QXData)

  const [activeTab, setActiveTab] = useState('0')

  useEffect(() => {
    getCheckPermissionFn()
  }, [])

  const getCheckPermissionFn = () => {
    const itemCode = SJQXChecks.HYGLCKHZSJH
    dispatch(getCheckPermissionAsync({ itemCode: itemCode }))
      .then(unwrapResult)
      .then((res: any) => {
        setQXData(res)
      })
  }

  return (
    <div className={styles.wrap}>
      <Tabs
        className={styles.tabs}
        activeKey={activeTab}
        onChange={(key) => setActiveTab(key)}
        destroyInactiveTabPane
      >
        <TabPane tab="充值明细" key="0">
          <RechargeRecord SJHQXData={QXData} />
        </TabPane>
        <TabPane tab="消费明细" key="1">
          <ConsumptionRecord SJHQXData={QXData} />
        </TabPane>
        <TabPane tab="会员明细" key="2">
          <ExchangeRecord SJHQXData={QXData} />
        </TabPane>
      </Tabs>
    </div>
  )
}
